import { IMaterialsResponse } from "@miplatform/types";
import { toUpperCase } from "@miplatform/utils";

export const getMaterialLabel = (item?: IMaterialsResponse | null) => {
  if (!item) return "";
  const partNumber = item.manufacturerPartNumber ?? "";
  const description =
    item.category?.itemDescription ?? item.manufacturerDescription ?? "";
  return `${toUpperCase(partNumber)} | ${toUpperCase(description)}`;
};
